<app-permissions-tree (permissionsChanged)="handlePermissionChanged($event)"
  [assignedPermissionGroupsEndPoint]="endPoint" />

<div class="d-flex justify-content-between bg-white">
  <button type="button" class="btn btn-outline-main" (click)="onClose()">
    {{"GENERAL.CANCEL" | translate}}
  </button>
  <button class="btn btn-solid-main" (click)="handleSubmit()">
    {{"GENERAL.SUBMIT" | translate}}
  </button>
</div>
